// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const CloseSidebarIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="CloseSidebarIcon" ref={forwardedRef} {...props}>
      <path d="M13.08 12.828 10.252 10l2.828-2.828L14 8.094l-1.94 1.94 1.909 1.909z" />
      <path d="M4 3a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm.5 1.5h2v11h-2zm3.5 0h7.5v11H8z" />
    </SvgIcon>
  );
});

/**
 * Use to collapse the sidebar. Use ChevronLeftDoubleIcon for others
 * @public
 */
export const CloseSidebarIcon = /* @__PURE__ */ Object.assign(
  CloseSidebarIconComponent,
  { displayName: 'CloseSidebarIcon' },
);
